import { CreateOrEdit } from "./CreateOrEdit";
import { Table } from "./Table";

export const UserPage = {
	Table,
	CreateOrEdit,
};
